export default "__VITE_ASSET__BkFHkmY4__"